import React, { forwardRef } from 'react';

import style from './TextareaShallow.scss';

export const TextareaShallow = forwardRef(({ className = '', autoResize, ...other }, ref) => (
    <textarea
        className={`${style.textarea} ${className} ${autoResize ? '' : style.noResize}`}
        ref={ref}
        {...other}
    />
));
